export default __webpack_public_path__ + "static/media/absorbante.0f00d1bb.jpg";